import type { TranscribeCredentialsResponse } from '@/api/types';

const REFRESH_MARGIN_MS = 120_000;

export type TranscribeCredentialsApi = {
  createTranscribeCredentials(): Promise<TranscribeCredentialsResponse>;
};

export const createTranscribeCredentialsProvider = (api: TranscribeCredentialsApi) => {
  let cached: TranscribeCredentialsResponse | null = null;
  let pending: Promise<TranscribeCredentialsResponse> | null = null;

  return async (): Promise<TranscribeCredentialsResponse> => {
    if (
      cached !== null
      && Date.parse(cached.credentials.expiration) - Date.now() > REFRESH_MARGIN_MS
    ) {
      return cached;
    }
    if (pending !== null) return pending;
    pending = api.createTranscribeCredentials()
      .then((response) => {
        cached = response;
        return response;
      })
      .finally(() => {
        pending = null;
      });
    return pending;
  };
};
